// -- 시용예시 : ServicesImageSetPreview --

import { useState } from "react";
import { IoIosHeart, IoMdRemoveCircleOutline } from "react-icons/io";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

export default function ImageOnClick({
  url,
  text,
  iid,
  onRemove,
  disabled,
  onSelect,
  titleImg,
  titleImgAbj,
  sortable,
}) {
  const [zoomPopup, setZoomPopup] = useState(false);
  const [errorNumber, setErrorNumber] = useState(1);

  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: iid ?? "non-sortable", disabled: !sortable || disabled });

  const onPopup = () => {
    setZoomPopup(!zoomPopup);
  };

  const isValidImageUrl = (url) => {
    return typeof url === "object" && url.storagePath;
  };

  if (!isValidImageUrl(url)) {
    return null;
  }

  // 대표 이미지 여부에 따라 클래스 이름 조건부 할당
  const imageClass = titleImg ? "image titleImg" : "image normalImg";

  const style = sortable
    ? {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.4 : 1,
        cursor: disabled ? "default" : "grab",
      }
    : undefined;

  return (
    <div
      ref={sortable ? setNodeRef : undefined}
      style={style}
      className={titleImg ? " titleImgContainer" : "normalImgContainer"}
      {...(sortable ? attributes : {})}
    >
      {iid && !disabled && (
        <>
          <button
            type="button"
            onClick={(e) => {
              e.preventDefault();
              onRemove(iid);
            }}
          >
            <IoMdRemoveCircleOutline />
          </button>
          {onSelect && (
            <button
              type="button"
              className="imgHeartBtn"
              onClick={(e) => {
                e.preventDefault();
                onSelect(iid);
              }}
            >
              <IoIosHeart className={titleImg ? " titleImgHeart" : ""} />
            </button>
          )}
        </>
      )}

      <img
        alt={text}
        src={url?.storagePath.replace("com/", "com/s/")}
        onError={(e) => {
          if (errorNumber === 1) {
            e.target.src = url.storagePath;
            setErrorNumber((res) => res + 1);
          } else {
            e.target.src = "./data/errorimage.png";
          }
          return;
        }}
        onClick={onPopup}
        className={imageClass}
        style={titleImgAbj ? { height: "63px" } : undefined}
        {...(sortable && !disabled ? listeners : {})}
      />
      <span className="blind">{text}</span>
      {zoomPopup && (
        <div
          className="imageZoomPopupBox"
          onClick={onPopup}
          style={{ height: "100%" }}
        >
          <img className="imageZoom" alt={text} src={url?.storagePath} />
        </div>
      )}
    </div>
  );
}
